import { PayloadAction } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import {
  ProjectTemplateStore,
  ProjectTemplateProjectPhase,
  ProjectTemplateTask,
} from '../types';
import { insert } from '../utils';

export const entitiesSlice = {
  updateProjectPhaseTemplateEntityOrder: (
    state: ProjectTemplateStore,
    {
      payload,
    }: PayloadAction<{
      entity: ProjectTemplateTask;
      entityId: string;
      projectPhase?: Pick<ProjectTemplateProjectPhase, 'projectPhaseId'>;
      parentTask?: Pick<ProjectTemplateTask, 'taskId'>;
      insertAt?: number;
    }>,
  ): ProjectTemplateStore => {
    const previousPhaseId = payload.entity.projectPhase?.projectPhaseId;
    let updated: ProjectTemplateStore;

    if (previousPhaseId) {
      const previousEntityOrder =
        state.data[state.activeId].projectPhases[previousPhaseId].entityOrder ??
        [];

      updated = dotPropImmutable.set(
        state,
        `data.${state.activeId}.projectPhases.${previousPhaseId}.entityOrder`,
        previousEntityOrder.filter((id) => id !== payload.entityId),
      );
    }

    updated ??= state;
    const phaseId = payload.projectPhase?.projectPhaseId;

    if (!phaseId) {
      return updated;
    }

    const order = dotPropImmutable.get(
      updated,
      `data.${state.activeId}.projectPhases.${phaseId}.entityOrder`,
      [],
    );

    return dotPropImmutable.set(
      updated,
      `data.${state.activeId}.projectPhases.${phaseId}.entityOrder`,
      insert(order, payload.insertAt ?? -1, payload.entityId),
    );
  },
};
